<div class="pageheader">
  <div class="page-title">
    <h1>Tracking Search Result</h1>
    <div class="btn-group" data-toggle="buttons">
      <button class="btn btn-link" *bizPermissionRequired="'Tracking_Action_SaveSearch'" (click)="saveSearch()"
        id="saveButton">
        Save Search <ep-svg-icon icon="SaveSearch"></ep-svg-icon>
      </button>
      <button class="btn btn-link" (click)="refresh()" id="saveButton">
        Refresh Data <ep-svg-icon icon="repeat"></ep-svg-icon>
      </button>
    </div>
  </div>

  <div class="pageheader-warnings">
    <restricted-search-callout
      [visible]="$safeNavigationMigration(stateObject.searchResult?.IsTrackingSearchResultRestricted)">
    </restricted-search-callout>

    <restricted-search-callout
      [visible]="$safeNavigationMigration(stateObject.searchResult?.IsMaxSearchResultReached)"
      header="Showing {{stateObject.searchResult?.MaxSearchResult}} documents",
      [type]="RestrictedSearchCalloutType.Warning"
      text="These are the newest documents matching your search. Refine your search to see older documents.">
    </restricted-search-callout>
  </div>
</div>

@if(stateObject.searchResult?.DistributionGroups?.length > 1){
  <div class="controls-inline"
  [class.has-warnings]="stateObject.searchResult?.IsTrackingSearchResultRestricted || stateObject.searchResult?.IsMaxSearchResultReached">
  @for(group of stateObject.searchResult?.DistributionGroups; track group.DistributionObjectGroupName){
    <div class="control control-checkbox" [class.active]="group.selected">
      <label [title]="group.DistributionObjectGroupDescription !== null ? group.DistributionObjectGroupDescription : ''">
        {{group.DistributionObjectGroupName}}
        <input type="checkbox" [(ngModel)]="group.selected" (ngModelChange)="selectedGroupsChanged()">
        <i></i>
      </label>
    </div>
  }
</div>
}

<div class="nav-tabs-filter">
  <ul class="nav-tabs" ngbNav [(activeId)]="stateObject.selectedDistributionObjectContainer" (activeIdChange)="selectedDistributionObjectsChanged()">
    @for (item of stateObject.distributionObjectsContainers; track item) {
      <li [ngbNavItem]="item">
        <a ngbNavLink [title]="item.DistributionObjectDescription" class="btn">{{item.DistributionObjectName}} ({{item.Documents.length}})</a>
      </li>
    }
  </ul>
</div>

<div class="btn-toolbar">
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_View_DocumentDetails'"
      [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="showDocuments()" id="showDocumentsButton">Show
    Documents</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_Resend'"
    [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="resend()" id="resendButton">Resend</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ManuallyHandle'"
      [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="handleManually()"
    id="manuallyHandleButton">Manually Handle</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_OnHold'"
    [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="onHold()">On Hold</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_CancelMessage'"
    [disabled]="!canCancelMessage()" (click)="cancelMessage()">Cancel Messages</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ExportFilesZipped'"
      [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="export()" id="exportButton">Export
    Files</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_CompareFiles'"
    [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="compareDocuments()">Compare Files</button>
  </div>
  <div class="btn-group">
    <button class="btn btn-primary btn-sm" *bizPermissionRequired="'TestTool_Action_TestCase_Edit'"
    [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0" (click)="addToTestCase()">Add to Test Case</button>
  </div>

  @if(showChangeStakeholder()){
    <div class="btn-group">
      <span
        [attr.title]="disableChangeStakeholder() ? 'Change Stakeholder can only be used when all selected rows have status &quot;Failed&quot;' : null">
        <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ChangeStakeholder'"
          [disabled]="disableChangeStakeholder()" (click)="changeStakeholder()">
          Change Stakeholder
        </button>
      </span>
    </div>
  }

  @for (trackingUiAction of trackingUiActions; track trackingUiAction) {
    <div class="btn-group">
      <button class="btn btn-primary btn-sm" *bizPermissionRequired="'Tracking_Action_ExecuteILinkTrackingAction'"
        [title]="trackingUiAction.Name" [disabled]="$safeNavigationMigration(stateObject.selectedRows?.length) <= 0"
      (click)="runTrackingUiAction(trackingUiAction)">{{trackingUiAction.Name}}</button>
    </div>
  }
</div>

<dx-data-grid id="gridContainer"
  biz-grid
  (onRefresh)="refresh()"
  exportFileName="Tracking Result"
  stateStorageKey="Tracking"
  viewStateKey="Tracking"
  [viewStateExcludedColumns]="['DocumentType']"
  [viewStateTrackingFieldPrefix]="trackingFieldPrefix"
  (bizViewStateChanging)="onViewStateChanging($event)"
  (bizViewStateChanged)="onViewStateChanged($event)"
  [dataSource]='$safeNavigationMigration(stateObject?.documents)'
  [keyExpr]="['InterchangeInGuid', 'DocumentId']"
  [selection]='{ mode: "multiple" }'
  [showCollapseAllButton]="true"
  [bizSetScrolling]="false"
  (bizGridReset)="gridResetButtonPressed()"
  (onSelectionChanged)='selectionChanged($event)'
  bizRowsSelectedTemplate='rowsSelected'>

  <!-- Notice! The keyExpr must be a combined key because we show both interchanges and documents - and the key MUST be unique.
  This is set to prevent very large state-configs when saving the grid-state. If not this is set, the complete row will be
  stored (for each selected row) - which can cause large sizes like 11-12mb -->

  <dxo-filter-row [visible]="showFilterRow"></dxo-filter-row>

  <dxi-column dataField="DistributionObjectName" name="DocumentType" caption="Document Type" dataType="string" width="180"
  [visible]="stateObject.showDistributionObjectColumn"></dxi-column>
  <dxi-column dataField="DocumentId" caption="Document Id" dataType="number" [visible]="false"></dxi-column>

  <dxi-column dataField="DocumentNumber" caption="Document Number" dataType="string" [visible]="true"></dxi-column>
  <dxi-column dataField="LastStatus" caption="Last Status" dataType="string" cellTemplate="documentStatusTemplate" [visible]="true"></dxi-column>
  <dxi-column dataField="PartnerFrom" caption="Partner From" dataType="string" [visible]="true"></dxi-column>
  <dxi-column dataField="PartnerTo" caption="Partner To" dataType="string" [visible]="true"></dxi-column>
  <dxi-column dataField="CreatedDate" caption="Created date and time" dataType="date" [visible]="true" sortOrder="desc"
  [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
  <dxi-column dataField="CleanDate" caption="Created date" dataType="date" [visible]="false" [format]="dateTimeService.getDevExpressDateFunction"></dxi-column>
  <dxi-column dataField="DisplayAddressOut" caption="Destination Address" dataType="string" [visible]="true"></dxi-column>
  <dxi-column dataField="DistributionId" caption="Distribution Id" dataType="string" [visible]="true"></dxi-column>
  <dxi-column dataField="InterchangeOutNumber" caption="Interchange Out Number" dataType="string" [visible]="true"></dxi-column>
  <dxi-column dataField="TransmissionIdIn" caption="Transmission Id In" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="TransmissionIdOut" caption="Transmission Id Out" dataType="string" [visible]="false"></dxi-column>

  <dxi-column dataField="InterchangeInCreatedDate" caption="InterchangeIn Created Datetime" dataType="date" [visible]="false"
  [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
  <dxi-column dataField="InterchangeOutCreatedDate" caption="InterchangeOut Created Datetime" dataType="date" [visible]="false"
  [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
  <dxi-column dataField="ProcessingStart" caption="Processing Start Datetime" dataType="date" [visible]="false"
  [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
  <dxi-column dataField="ProcessingEnd" caption="Processing End Datetime" dataType="date" [visible]="false"
  [format]="dateTimeService.getDevExpressDateTimeFunction"></dxi-column>
  <dxi-column dataField="ProcessingTime" caption="Processing Time (from interchange-in to processing-end)" dataType="string" [visible]="false"></dxi-column>

  <!-- Error columns start -->
  <dxi-column dataField="ErrorCode" caption="Error Code" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="Stakeholder" caption="Stakeholder" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="FullExceptionMessage" caption="Full Exception Message" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="ExceptionMessage" caption="Exception Message" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="ExceptionCause" caption="Exception Cause" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="ExceptionSolution" caption="Exception Solution" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="ExceptionDescription" caption="Exception Description" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="ExceptionTechnicalDescription" caption="Exception Technical Description" dataType="string" [visible]="false"></dxi-column>
  <!-- Error columns end -->

  <dxi-column dataField="InterchangeInNumber" caption="Interchange In Number" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="FileNameIn" caption="Filename In" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="FileNameOut" caption="Filename Out" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="Priority" caption="Priority" dataType="number" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeOutId" caption="Interchange Out Id" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeInGuid" caption="Interchange In Guid" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeOutGuid" caption="Interchange Out Guid" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeOutPortName" caption="Interchange Out Port Name" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeInPortName" caption="Interchange In Port Name" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeOutDisplayAddress" caption="Interchange Out Display Address" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeInDisplayAddress" caption="Interchange In Display Address" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="TransportConfigurationOutName" caption="Transport Configuration Out Name" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="FormatVariantVersionFrom" caption="From Format/Variant/Version" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="FormatVariantVersionTo" caption="To Format/Variant/Version" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="InterchangeOriginatingId" caption="Interchange Originating ID" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="DocumentOriginatingId" caption="Document Originating ID" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="PartnerSystemInName" caption="Partner System In" dataType="string" [visible]="false"></dxi-column>
  <dxi-column dataField="PartnerSystemOutName" caption="Partner System Out" dataType="string" [visible]="false"></dxi-column>

  <!-- Tracking Field Columns -->
  @for (trackingField of stateObject?.selectedDistributionObjectContainer?.TrackingFields; track trackingField) {
    <dxi-column
      [dataField]="trackingFieldPrefix + '' + trackingField.TrackingFieldTypeId" [caption]="trackingField.TrackingFieldDisplayName" dataType="string"
    [visible]="currentViewState?.ShowTrackingFields ?? true"></dxi-column>
  }
  <div *dxTemplate="let document of 'documentStatusTemplate'">
    <ep-tracking-status [currentStatus]="document.data.LastStatus"></ep-tracking-status>
  </div>

  <div *dxTemplate="let data of 'rowsSelected'">
    <span style="margin-right: 4em; text-wrap: nowrap;">Number of selected rows: {{ data.counter.selectedRows }}</span>
  </div>
</dx-data-grid>
<br/>
<br/>
<br/>
